export default class PageManagement {
  constructor(options) {

    this.focusModalInput();

    $(document).on('click', '#new-blank-page', this.showNewBlankPageModal.bind(this));
    $(document).on('click', '#new-internal-page', this.showNewPrivatePageModal.bind(this));
    $(document).on('click', '#new-external-link', this.showNewExternalLinkModal.bind(this));
    $(document).on('click', '#reorganize-pages', this.reorganizePages.bind(this));
  }

  focusModalInput() {
    $('#new-page-modal').on('shown.bs.modal', function () {
      $(this).find('input:text:visible:first').focus();
    });
  }

  showNewPageModal(title) {
    $('#new-page-modal .modal-title').text(title);
    $('#new-page-modal').modal('show');
  }

  showNewBlankPageModal() {
    this.showNewPageModal('New Blank Page');
    $('#new-page-modal .external-link-inputs').hide();
    $(document).off('submit', '#new-page-form')
               .on('submit', '#new-page-form', { new_page_type: "new" }, this.newPageValidation);
  }

  showNewPrivatePageModal() {
    $('#new_page_type').val('private');
    this.showNewPageModal('New Private Page');
    $('#new-page-modal .external-link-inputs').hide();
    $(document).off('submit', '#new-page-form')
               .on('submit', '#new-page-form', { new_page_type: "private" }, this.newPageValidation);
  }

  showNewExternalLinkModal() {
    $('#new_page_type').val('url');
    this.showNewPageModal('New External Link');
    $('#new-page-modal .external-link-inputs').show();
    $(document).off('submit', '#new-page-form')
               .on('submit', '#new-page-form', { new_page_type: "url" }, this.newPageValidation);
  }

  newPageValidation(event) {
    if ($('#page_title').val().length === 0) {
      event.preventDefault();
      $('#page_title').css('border', '2px solid #AC3B3B');
    }

    if (event.data.type === "external") {
      if ($('#page_external_url').val().length === 0) {
        event.preventDefault();
        $('#page_external_url').css('border', '2px solid #AC3B3B');
      }
    }
  }

  reorganizePages(event) {
    event.preventDefault();
    $('.reorganize-pages-button-cancel').on('click', this.reorganizePagesCancel);
    $('.reorganize-pages-button-save').on('click', this.reorganizePagesSave);

    $('.admin-input').hide();
    $('#page-management-sidebar').hide();
    $('.reorganize-pages-button-save').show();
    $('.reorganize-pages-button-cancel').show();

    $('.sidebar-child').addClass('no-nesting');

    $('.admin-sidebar-pages').nestedSortable({
      forcePlaceholderSize: true,
      opacity: 0.4,
      revert: 250,
      tabSize: 25,
      helper: 'clone',
      forcePlaceholderSize: true,
      placeholder: 'placeholder',
      disableNestingClass: 'no-nesting',
      handle: 'div',
      items: 'li',
      tolerance: 'pointer',
      toleranceElement: '> div',
      maxLevels: 2,
      isTree: true,
      startCollapsed: false,
      expandOnHover: 700,
      listType: 'ul',
      relocate: function() {
        $('.no-nesting').removeClass('no-nesting');
        $('.mjs-nestedSortable-branch .mjs-nestedSortable-leaf').addClass('no-nesting');
      }
    });
  }

  reorganizePagesSave(event) {
    event.preventDefault();

    var newOrder = $('.admin-sidebar-pages').nestedSortable('toArray', {startDepthCount: 0});

    var pageId = $('input[name$="page_id"]').val();
    $('.reorganize-pages-button-save').text('Working...');

    $.ajax({
      type: "POST",
      url: "/admin/pages/" + pageId + "/reorganize",
      data: {
        'page_list' : JSON.stringify(newOrder)
      },
      dataType: 'html',
      success: function(data, status) {
        window.location.reload();
      }
    });

  }

  reorganizePagesCancel(event) {
    event.preventDefault();
    window.location.reload();
  }
}
